const Swiper = window.Swiper;
const SELECTOR = '[data-blog-posts-slider]';
const INSTANCE_KEY = '_blogPostsSliderInstance';

class BlogPostsSlider {
  constructor(root) {
    this.root = root;
    this.swiper = null;
    this.abortController = new AbortController();

    this.init();
  }

  init() {
    const layout = this.root.dataset.layout || 'grid';
    if (layout !== 'slider') return;

    const sliderRoot = this.root.querySelector('.blog-posts-list__slider');
    const track = this.root.querySelector('.blog-posts-list__track');
    if (!sliderRoot || !track) return;

    const styles = getComputedStyle(this.root);
    const colsD = parseFloat(styles.getPropertyValue('--blog-cols-d')) || 3;
    const colsT = parseFloat(styles.getPropertyValue('--blog-cols-t')) || 2;
    const colsM = parseFloat(styles.getPropertyValue('--blog-cols-m')) || 1;
    const gapD = parseFloat(styles.getPropertyValue('--blog-col-gap-d')) || 16;
    const gapT = parseFloat(styles.getPropertyValue('--blog-col-gap-t')) || 16;
    const gapM = parseFloat(styles.getPropertyValue('--blog-col-gap-m')) || 16;

    const loop = this.root.dataset.loop === 'true';
    const autoplayOn = this.root.dataset.autoplay === 'true';
    const autoplayDelay = (parseFloat(this.root.dataset.autoplaySpeed) || 5) * 1000;

    const children = Array.from(track.children);
    if (children.length === 0) return;

    const swiperEl = document.createElement('div');
    swiperEl.className = 'swiper blog-posts-list__swiper';
    const wrapperEl = document.createElement('div');
    wrapperEl.className = 'swiper-wrapper';

    children.forEach((child) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide blog-posts-list__slide';
      slide.appendChild(child);
      wrapperEl.appendChild(slide);
    });

    swiperEl.appendChild(wrapperEl);
    track.replaceChildren(swiperEl);

    const prevEl = sliderRoot.querySelector('.slideshow-control--previous');
    const nextEl = sliderRoot.querySelector('.slideshow-control--next');

    /** @type {any} */
    const options = {
      slidesPerView: "auto",
      spaceBetween: gapM,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24,
      loop,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      autoplay: autoplayOn
        ? { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false,
      breakpoints: {
        768: {
          slidesPerView: colsT,
          spaceBetween: gapT,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
        992: {
          slidesPerView: colsD,
          spaceBetween: gapD,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    };

    if (prevEl && nextEl) {
      options.navigation = { prevEl, nextEl };
    }

    this.swiper = new Swiper(swiperEl, options);

    const setLocked = (locked) => {
      this.root.dataset.locked = locked ? 'true' : 'false';
    };
    setLocked(this.swiper.isLocked);
    this.swiper.on('lock', () => setLocked(true));
    this.swiper.on('unlock', () => setLocked(false));

    this.root.classList.add('is-initialized');
  }

  destroy() {
    this.abortController.abort();
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    delete this.root.dataset.locked;
  }
}

function initAll(root) {
  const scope = root || document;
  scope.querySelectorAll(SELECTOR).forEach((el) => {
    if (el[INSTANCE_KEY]) {
      el[INSTANCE_KEY].destroy();
    }
    el[INSTANCE_KEY] = new BlogPostsSlider(el);
  });
}

function destroyAll(root) {
  const scope = root || document;
  scope.querySelectorAll(SELECTOR).forEach((el) => {
    if (el[INSTANCE_KEY]) {
      el[INSTANCE_KEY].destroy();
      el[INSTANCE_KEY] = null;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll());
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (e) => initAll(e.target));
document.addEventListener('shopify:section:unload', (e) => destroyAll(e.target));
